function packSx(sx) {
    return Array.isArray(sx) ? sx : [
        sx
    ];
}
export { packSx }; //# sourceMappingURL=pack-sx.js.map
